
import { SelectionChangedEvent } from 'ag-grid-community';
import { CallGrid } from '../CallPanel/Grids/CallGrid';
import { Call } from './CallPanelTypes';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';

export class CallPanel {
    private readonly callPanelEl: HTMLElement;
    private readonly callsGrid: CallGrid;
    constructor() {
        this.callPanelEl = document.getElementById('CallControlPanel');

        const callsGridContainer = this.callPanelEl.querySelector('.callsGrid') as HTMLElement;
        this.callsGrid = new CallGrid(callsGridContainer);
    }
    async init() {
        await this.callsGrid.init();
    }
}
